import {useMemo} from "react";
import {useStore} from "hooks/useStore";
import {useFetch} from "hooks/useFetch";
import {TICKET_EXCLUDED_ROLES} from "constants/ticket";
import {sortByName} from "./ticketUtils";

// Departman (rol) seçenekleri: genel form-options ucu birçok role kapalı olduğundan talep ucundan alınır
export const useTicketOptions = () => {
    const stores = useStore();
    const [, response] = useFetch({
        fetchFn: stores.ticketStore.getTicketOptions,
        defaultDataValue: {}
    });
    const roleOptions = useMemo(
        () =>
            sortByName(
                (response?.data?.roles || []).filter(
                    role => !TICKET_EXCLUDED_ROLES.includes(role.key)
                )
            ),
        [response]
    );
    const roleLabels = useMemo(
        () => Object.fromEntries(roleOptions.map(role => [role.key, role.name])),
        [roleOptions]
    );
    return {roleOptions, roleLabels};
};
